import React, { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequestCcex, graphConfigCcex } from '../authConfigCcex';
import { Outlet, useLocation } from 'react-router-dom';
import axios from "axios";
import Cookies from 'js-cookie';
import { ComponenteSpinner } from '../pages/adminComponents/ComponenteSpinner';

const ALLOWED = (process.env.REACT_APP_ALLOWED_REDIRECTS || '')
  .split(',')
  .map((s) => s.trim())
  .filter(Boolean);

export const isAllowedRedirect = (url) => {
  try {
    const u = new URL(url);
    return ALLOWED.some((host) => u.origin === new URL(host).origin);
  } catch {
    return false;
  }
};

const ProtectedRouteEntraIDCcex = ({isAuth, setIsLogin }) => {
    const { instance, accounts } = useMsal();
    const location = useLocation();

    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [userNotInTable, setUserNotInTable] = useState(false);
    const [loading, setLoading] = useState(true);
    const [redirectAllowed, setRedirectAllowed] = useState(true);
    
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);

        const redirect = queryParams.get("redirect") || "/inicio";
        const redirectNoAuth = queryParams.get("noauth") || "/inicio";
        const token = Cookies.get("token");

        try {
            
            const url = new URL(redirect, window.location.origin);
            const urlNoAuth = new URL(redirectNoAuth, window.location.origin);

            const cleanRedirect = url.origin;
            const cleanRedirectNoAuth = urlNoAuth.origin;

            if (redirectNoAuth && cleanRedirect !== cleanRedirectNoAuth) {
                console.log("❌ Redirect no coincide");
                setRedirectAllowed(false);
                setLoading(false);
                return;
            }

            if (url.origin !== window.location.origin && (!isAllowedRedirect(redirect) || !isAllowedRedirect(redirectNoAuth))) {
                console.log("❌ Redirect no permitido:", cleanRedirect);
                setRedirectAllowed(false);
                setLoading(false);
                return;
            }

            if (redirect) {
                if (!sessionStorage.getItem("redirect_after_login")) {
                    sessionStorage.setItem("redirect_after_login", redirect);
                }
            }

            if (redirectNoAuth) {
                if (!sessionStorage.getItem("redirect_after_no_auth")) {
                    sessionStorage.setItem("redirect_after_no_auth", redirectNoAuth);
                }
            }

        } catch {
            console.log("❌ Redirect inválido:", redirect);
            setRedirectAllowed(false);
            setLoading(false);
            return;
        }

            // ✅ Si ya hay token en la query → ya está autenticado
        if (token) {
            return <Outlet />;
        }
        
        // if (redirect) {
        //     if (!sessionStorage.getItem("redirect_after_login")) {
        //         sessionStorage.setItem("redirect_after_login", redirect);
        //     }
        // }
                
        // 2️⃣ Si NO hay query string, ejecutamos el flujo de validación
        const validateToken = async () => {
            try {
                // Procesar redirect de Azure AD si viene un "code" en el hash
                /*if (window.location.hash.includes("code=")) {
                    await instance.handleRedirectPromise();
                }*/
                const hasRedirect = window.location.hash.includes("code=") || window.location.hash.includes("state=");
                if (hasRedirect && !sessionStorage.getItem("entra_login_done")) {
                    sessionStorage.setItem("entra_login_done", "1");

                    await instance.handleRedirectPromise().then((response) => {
                        if (response) {
                            // Puedes guardar el usuario, si quieres
                            console.log("Login response:", response.account.name);
                        }
                        // 🧼 Limpia el hash del URL (deja la ruta limpia)
                        window.history.replaceState({}, document.title, window.location.pathname + location.search);
                    }).catch((e) => {
                        console.error("MSAL error:", e);
                    });
                }                
                
                if (accounts.length > 0) {
                    var response ="";
                    try {
                        response = await instance.acquireTokenSilent({
                            ...loginRequestCcex,
                            account: accounts[0]
                        });
                    } catch (error) {
                    console.warn("⚠️ Silent token acquisition failed", error);
                    // quizás puedes redirigir antes en vez de esperar
                    }
                    // Validar en Graph API
                    const graphResponse = await fetch(graphConfigCcex.graphMeEndpoint, {
                        method: 'GET',
                        headers: {
                            Authorization: `Bearer ${response.accessToken}`
                        }
                    });

                    if (!graphResponse.ok) {
                        throw new Error('Token inválido en Graph');
                    }

                    // Lógica extra: obtener token de tu API y guardarlo en cookies
                    const email = accounts[0].username;

                    // AQUI REALIZAR VALIDACION CON API EXT A PARTIR DE EMAIL
                    const apiResp = await axios.get(
                        `${process.env.REACT_APP_API_EXT}/Account/ObtenerPersonaToken?email=${email}`
                    );


                    if (!apiResp.data?.status?.isSuccessfully) {
                        setIsAuthenticated(false);
                        setUserNotInTable(true);
                        return;
                        //se debe mostrar algun mensaje de que el usuario no esta registrado
                    }

                    Cookies.set("token", apiResp.data.data.jwtToken, { expires: 1 });
                    // Cookies.set("DatosPersonalesGIA.CAS", "Logeado con EID", { expires: 1 });
                    setIsLogin(true);
                   // alert("Se agregaron los cookies de token")
                    setIsAuthenticated(true);
                    sessionStorage.removeItem("entra_login_done");

                    //alert(isAuth);
                } else {
                    setIsAuthenticated(false);
                    //alert(isAuth);

                }
            } catch (error) {
                console.error("❌ Error en autenticación:", error);
                setIsAuthenticated(false);
            } finally {
                setLoading(false);
            }
        };

        validateToken();
    }, [location.search, accounts, instance]);

    if (userNotInTable && sessionStorage.getItem("redirect_after_no_auth")) {
        console.log("🔄 Usuario no autorizado, redirigiendo a no auth...");
        
        const noAuth = sessionStorage.getItem("redirect_after_no_auth");
        if (noAuth) {
            sessionStorage.removeItem("redirect_after_no_auth");
            window.location.href = noAuth;
        } else {
            window.location.href = '/inicio';
        }
        return null;
    }

    if (!redirectAllowed) {
        console.log("❌ Sitio no autorizado para usar el login...");
        return <div>❌ Sitio no autorizado para usar el login.</div>;
    }

    if (loading) {
        console.log("🔄 Cargando estado de autenticación...");
        //alert("Cargando estado de autenticación...: "+ isAuth);
        return <ComponenteSpinner></ComponenteSpinner>;
    }

    if (!isAuthenticated && !window.location.hash.includes("code=") && !sessionStorage.getItem("entra_login_done")) {
        console.log("🔄 Usuario no autenticado, redirigiendo al login de Microsoft...");
        instance.loginRedirect({
            ...loginRequestCcex,
            redirectUri: window.location.href
        });
        return null;
    }
    
    if (loading || !isAuthenticated || !Cookies.get("token")) {
        console.log("🔄 Usuario no autenticado...");

        return <ComponenteSpinner />;
    }

    console.log("✅ Usuario autenticado, renderizando la ruta protegida.");
    return <Outlet />;
};

export default ProtectedRouteEntraIDCcex;